// extracted by mini-css-extract-plugin
export default {"wrapper":"amountToggle_wrapper__Uuf0y","label":"amountToggle_label__F8sLZ"};